import { useRef } from 'react'
import { useGlobalMatter } from 'views/InhouseGame/hooks/useMatter'
import { plinkoSizes, plinkoDistancesX, plinkoDistancesY, canvasWidth, wallWidth, startYPlinko } from '../../../config'
import Wall from '../modals/Wall'

const useGameWalls = (row: number) => {
  const Matter = useGlobalMatter()

  const wallsRef = useRef([])
  const size = plinkoSizes[row]
  const [x, y] = [plinkoDistancesX[row], plinkoDistancesY[row]]

  const updateWalls = () => {
    const startX = (canvasWidth - (row + 1) * x) / 2
    const previousWalls = wallsRef.current.splice(0, wallsRef.current.length)

    wallsRef.current.push(
      new Wall(Matter, {
        startX: startX + ((row - 1) * x) / 2 - wallWidth - size,
        endX: startX - wallWidth - size,

        startY: startYPlinko,
        endY: startYPlinko + (row - 1) * y,

        row,
        width: wallWidth,
      }),
    )

    wallsRef.current.push(
      new Wall(Matter, {
        startX: startX + ((row + 3) * x) / 2 + size + wallWidth,
        endX: startX + (row + 1) * x + size + wallWidth,

        startY: startYPlinko,
        endY: startYPlinko + (row - 1) * y,

        row,
        width: wallWidth,
      }),
    )

    return {
      new: wallsRef.current,
      old: previousWalls,
    }
  }

  return {
    updateWalls,
    walls: wallsRef.current,
  }
}

export default useGameWalls
